module.exports = __webpack_public_path__ + "images/emoji/neutral_face.1940913b3c5e43003a2e.png";